const appConfig = {
  //production
  apiPrefix: "https://api.askred.ai",

  //development
  apiDevPrefix: "https://devapi.askred.ai",

  authenticatedEntryPath: "/home",
  unAuthenticatedEntryPath: "/sign-in",
  tourPath: "",
  enableMock: false,
};

export default appConfig;
